// React 19 hoists a page's <title>, <meta> and <link> into <head> but leaves
// the static ones from index.html in place. Once a React-rendered tag of a
// kind exists, drop its static twin so crawlers and browsers see one of each.
const KINDS = [
    'title',
    'meta[name="description"]',
    'link[rel="canonical"]',
    'meta[name="robots"]',
    'meta[property="og:type"]',
    'meta[property="og:title"]',
    'meta[property="og:description"]',
    'meta[property="og:url"]',
    'meta[property="og:image"]',
    'meta[property="og:image:width"]',
    'meta[property="og:image:height"]',
    'meta[property="og:image:alt"]',
    'meta[name="twitter:title"]',
    'meta[name="twitter:description"]',
    'meta[name="twitter:image"]',
    'script[data-page-ld]',
];

export function dropStaticHeadTwins() {
    if (typeof document === 'undefined') return;
    for (const kind of KINDS) {
        const all = document.head.querySelectorAll(kind);
        if (all.length < 2) continue;
        const hasLive = Array.from(all).some((el) => !el.hasAttribute('data-static'));
        if (!hasLive) continue;
        all.forEach((el) => { if (el.hasAttribute('data-static')) el.remove(); });
    }
}

// Pages load on demand, so their tags can land in <head> after the route
// effect has already run. Watch <head> and drop twins whenever it changes.
let observer;
export function watchStaticHeadTwins() {
    if (typeof MutationObserver === 'undefined' || observer) return;
    observer = new MutationObserver(() => dropStaticHeadTwins());
    observer.observe(document.head, { childList: true });
    dropStaticHeadTwins();
}
